export const global_font_path = {
  "name": "--pf-global--font-path",
  "value": "./assets/fonts",
  "var": "var(--pf-global--font-path)"
};
export default global_font_path;